import { Link } from "react-router-dom";
import { Send, MessageCircle } from "lucide-react";
import { useEffect, useState } from "react";
import api, { resolveImg } from "@/lib/api";
import { useSettings } from "@/lib/settings";

export default function Footer() {
    const settings = useSettings();

    const logoUrl = settings?.logo_url ? resolveImg(settings.logo_url) : null;

    return (
        <footer className="bg-[#09090b] border-t border-white/5" data-testid="footer">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12 py-10 sm:py-16">
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 sm:gap-12">
                    <div>
                        {logoUrl && <img src={logoUrl} alt="AutoTreider" className="h-16 mb-4" />}
                        <p className="text-zinc-500 text-sm leading-relaxed">
                            {settings?.company_description || "Продажа автомобилей из Европы"}
                        </p>
                    </div>
                    <div>
                        <h4 className="text-white text-sm uppercase tracking-wider font-bold mb-6">Навигация</h4>
                        <div className="flex flex-col gap-3">
                            <Link to="/catalog" className="text-zinc-500 hover:text-white text-sm transition-colors">Каталог</Link>
                            <Link to="/configurator" className="text-zinc-500 hover:text-white text-sm transition-colors">Конфигуратор</Link>
                            <Link to="/services" className="text-zinc-500 hover:text-white text-sm transition-colors">Услуги</Link>
                            <Link to="/reviews" className="text-zinc-500 hover:text-white text-sm transition-colors">Отзывы</Link>
                            <Link to="/blog" className="text-zinc-500 hover:text-white text-sm transition-colors">Блог</Link>
                            <Link to="/contacts" className="text-zinc-500 hover:text-white text-sm transition-colors">Контакты</Link>
                        </div>
                    </div>
                    <div>
                        <h4 className="text-white text-sm uppercase tracking-wider font-bold mb-6">Контакты</h4>
                        <div className="flex flex-col gap-3">
                            {settings?.managers?.map((m, i) => (
                                <div key={i} className="mb-3">
                                    <span className="text-white text-sm block mb-1.5">{m.name}</span>
                                    <div className="flex gap-2">
                                        {m.telegram && (
                                            <a href={m.telegram} target="_blank" rel="noopener noreferrer" className="flex items-center gap-1.5 bg-[#0099FF]/10 border border-[#0099FF]/30 text-[#0099FF] text-xs px-3 py-1.5 hover:bg-[#0099FF]/20 transition-all">
                                                <Send className="w-3 h-3" /> Telegram
                                            </a>
                                        )}
                                        {m.whatsapp && (
                                            <a href={m.whatsapp} target="_blank" rel="noopener noreferrer" className="flex items-center gap-1.5 bg-emerald-500/10 border border-emerald-500/30 text-emerald-400 text-xs px-3 py-1.5 hover:bg-emerald-500/20 transition-all">
                                                <MessageCircle className="w-3 h-3" /> WhatsApp
                                            </a>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4">
                    <p className="text-zinc-600 text-xs">
                        &copy; {new Date().getFullYear()} {settings?.footer_copyright || ""}
                    </p>
                    {settings?.telegram_channel_url && (
                        <a
                            href={settings.telegram_channel_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center gap-2 text-[#0099FF] text-xs uppercase tracking-wider hover:text-white transition-colors"
                            data-testid="footer-telegram-link"
                        >
                            <Send className="w-3 h-3" />
                            {settings.telegram_channel_button_text || "Telegram"}
                        </a>
                    )}
                </div>
            </div>
        </footer>
    );
}
